import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3f15bf68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about-intro" }
const _hoisted_2 = { class: "container about-intro__wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "about-intro__text" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "about-intro__label" }, "О компании"),
  /*#__PURE__*/_createElementVNode("h1", { class: "about-intro__title" }, [
    /*#__PURE__*/_createTextVNode(" Мы создаём пространство "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "безопасного B2B")
  ])
], -1))
const _hoisted_4 = { class: "about-intro__desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "about-intro__paragraph" }, " X-Global — это российская B2B-платформа, где каждая сделка начинается с анализа контрагента. Мы объединяем проверку, витрину и сделку в одном месте — чтобы бизнес мог работать без риска. ", -1))
const _hoisted_6 = {
  key: 0,
  class: "about-intro__btn",
  "data-bs-toggle": "modal",
  "data-bs-target": "#authModal"
}

import { computed } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'IntroSection',
  setup(__props) {

const store = useStore();
const loggedIn = computed(() => store.state.auth.status.loggedIn);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (!loggedIn.value)
          ? (_openBlock(), _createElementBlock("button", _hoisted_6, " Попробовать бесплатно "))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})